import classNames from 'classnames';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import IconBox from '../../../../components/IconBox';
import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import TypesService from '../../../../services/TypesService';
import './DetailSheet.scss';

const DetailSheet = ({ className, currency, sender, recipient, category, date, txId }) => {
	const formatDateWithTime = date => {
		const d = new Date(date);

		const base = HelperService.formatDate(d, '/', 10, '', true);

		const hh = String(d.getHours()).padStart(2, '0');
		const min = String(d.getMinutes()).padStart(2, '0');

		return `${base.slice(2)} ${hh}:${min}`;
	};

	const copy = () => {
		navigator.clipboard.writeText(txId);

		HelperService.showNotification({
			icon: 'DOCUMENTS_ICON_PURPLE',
			title: t('Address copied'),
			description: HelperService.middleEllipsis(txId),
			iconSize: 32,
		});
	};

	const currencyById = TypesService.CurrenciesById[currency];
	const currencyBlockchainData = TypesService.BlockchainsById[currencyById?.BlockchainId];

	return (
		<div className={classNames('DetailSheet FormBlock', className)}>
			{currency && (
				<div className='DetailSheet__currency'>
					<div className='DetailSheet__currency-label'>Currency</div>
					<div className='DetailSheet__currency-icon'>
						<div>
							<IconBox icon={currencyById.CompanyIcon} iconLabel={currencyBlockchainData.Icon} size={24} />
						</div>
						<div className='DetailSheet__currency-icon-text'>
							{currencyById.Name} {currencyBlockchainData.Name} ({currencyById.Standart})
						</div>
					</div>
				</div>
			)}

			<div className='DetailSheet__from'>
				<div className='DetailSheet__from-label'>{t('From')}</div>
				<div className='DetailSheet__from-address'>{sender}</div>
			</div>
			{recipient && (
				<div className='DetailSheet__to'>
					<div className='DetailSheet__to-label'>{t('To')}</div>
					<div className='DetailSheet__to-address'>{recipient}</div>
				</div>
			)}

			{category && (
				<div className='DetailSheet__category'>
					<div className='DetailSheet__category-label'>{t('Category')}</div>
					<div className='DetailSheet__category-title'>
						<div className='DetailSheet__category-name'>
							<Icon type={Icons.PERSON} width={16} height={16} />
							<p>Products</p>
						</div>
					</div>
				</div>
			)}

			<div
				className='DetailSheet__date'
				style={txId ? { borderBottom: ' 1px solid rgb(var(--separator-nonOpaque))' } : {}}
			>
				<div className='DetailSheet__date-label'>{t('Date')}</div>
				<div className='DetailSheet__date-date'>{formatDateWithTime(date)}</div>
			</div>
			{txId && (
				<div className='DetailSheet__txId'>
					<div className='DetailSheet__txId-label'>TxID</div>
					<div className='DetailSheet__txId-id'>
						{HelperService.middleEllipsis(txId, 6)}{' '}
						<Icon type={Icons.DOCUMENTS_ICON} width={24} height={24} onClick={copy} />
					</div>
				</div>
			)}
		</div>
	);
};

export default DetailSheet;
